import { Button } from 'antd';
import React, { useState, useEffect } from 'react';
import './index.css'
import {useNavigate} from "react-router-dom";
import { CheckOutlined } from '@ant-design/icons';

import { useSupplierEntry } from 'hooks/supplier-entry';

interface props {
  enums?: any
  enumsName?: any
  current?:any
  authStatus?:any
}


const SPHeader: React.FC<props> = (props) => {
  const { authStatus } = props;
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingUrl, setLoadingUrl] = useState(false);
  const [step, setStep] = useState(1);
  const [authUrl, setAuthUrl] = useState<string>('');
  const goEnterPage = () => {
    navigate('/supplier-entry')
  }

  const { pay_deposit_status, auth_status, seal_status, text } = authStatus || {};

  const { getAuthUrl, getSealAuthUrl, getAuthStatus } = useSupplierEntry();

  const stepItems:any=[
    {
      title: '商户入网申请',
      // subTitle: '00:00:05',
      // status: 'finish',
      // description: 'This is a description.',
    },
    {
      title: '电子签章授权',
      // subTitle: '00:01:02',
      // status: 'process',
      // description: 'This is a description.',
    },
    {
      title: '印章免认证',
      // subTitle: 'waiting for longlong time',
      // status: 'wait',
      // description: 'This is a description.',
    },
  ]

  const stepItemStyle: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    padding: '0 16px',
    height: 30,
    borderRadius: '15px',
    lineHeight: '30px',
    background: '#fff',
    color: '#FF6400',
    border: '1px solid #FF6400'
  };

  const lineStyle: React.CSSProperties = {
    display: 'inline-block',
    margin: '0 16px',
    width: '36px',
    height: '1px',
    background: '#ccc',
  }

  const dotStyle: React.CSSProperties = {
    marginRight: 8,
    display: 'inline-block',
    width: 4,
    height: 4,
    borderRadius: '50%',
    background: '#999'
  }

  const doneStyle = {
    color: '#FF6400',
    border: '1px solid #FF6400'
  }

  const processingStyle = {
    color: '#FF6400',
    border: '1px solid #FF6400'
  }

  const waitStyle = {
    color: '#333333',
    border: '1px solid #CCCCCC',
  }

  const handleAuthUrlGet = () => {
    setLoadingUrl(true);
    getAuthUrl({}).then((res: any) => {
      setAuthUrl(res?.data?.auth_url);
      setLoadingUrl(false);
    }).catch(() => {
      setLoadingUrl(false);
    });
  }

  const handleSealAuthUrlGet = () => {
    setLoadingUrl(true);
    getSealAuthUrl({}).then((res: any) => {
      setAuthUrl(res?.data?.seal_auth_url);
      setLoadingUrl(false);
    }).catch(() => {
      setLoadingUrl(false);
    });
  }

  
  const getTargetStyle = (index: number) => {
    if (step > index) {
      return doneStyle;
    };
    if (step === index) {
      return processingStyle;
    };
    if (step < index) {
      return waitStyle;
    };
    return {};
  }

  const getDotStyle = (index: number) => {
    if (step > index) {
      return {
        background: '#FF6400'
      };
    };
    if (step === index) {
      return {
        background: '#FF6400'
      };;
    };
    if (step < index) {
      return {
        background: '#999'
      };;
    };
    return {};
  }

  const handleIframeClose = () => {
    setAuthUrl('');
  }

  useEffect(() => {
    if (pay_deposit_status !== 1) {
      setStep(1);
    };
    if (pay_deposit_status === 1 && auth_status !== 1) {
      setStep(2);
    }
    if (pay_deposit_status === 1 && auth_status === 1 && seal_status !== 1) {
      setStep(3);
    }
    if (pay_deposit_status === 1 && auth_status === 1 && seal_status === 1) {
      setStep(4);
    }
  }, [pay_deposit_status, auth_status, seal_status]);

  return (
    <>
      <div style={{ marginBottom: 12, fontSize: 18, color: '#1F1F1F', fontWeight: 500, display: 'flex', alignItems: 'center' }}>
        <img src="https://s.didi-trip.com/yks-prod/image/zuche-sass-miwx/merchant.svg" style={{ width: 26, height: 26, marginRight: 4 }} />
        商户接单配置流程
      </div>
      {authUrl
        ? (
          <>
            <Button style={{ marginBottom: 12 }} onClick={handleIframeClose}>关闭</Button>
            <div style={{ height: '100%', overflowY: 'auto' }}>
              <iframe style={{ width: '100%', height: '100%', border: '1px solid #ccc' }} src={authUrl}></iframe>
            </div>
          </>
        )
        : <div style={{ marginBottom: 20, padding: 20, backgroundImage: "url('https://s.didi-trip.com/yks-prod/image/zuche-sass-miwx/entry-step-bg.png')", backgroundSize: '100% 100%' }}>
          <div className="tip-line" style={{ display: 'flex', alignItems: 'center' }}>

            { stepItems.map((item: any, index: number) => {
              return (
                <>
                  <div style={{ ...stepItemStyle, ...getTargetStyle(index + 1)}}>
                  { index + 1 < step ? <CheckOutlined style={{ marginRight: 8 }} /> : <span style={{...dotStyle, ...getDotStyle(index + 1)}}></span>}
                  {item.title}</div>
                  {index + 1 < stepItems?.length && <span style={lineStyle}></span>}
                </>
              )
            })}

          </div>
          {step < 4 && <div className="status-line" style={{ marginTop: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ fontSize: '16px', fontWeight: 600, color: 'rgba(0, 0, 0, 0.88)' }}>
              {text}
            </div>
            { step === 1 && <Button type='primary' onClick={goEnterPage}>
              申请入网
            </Button>}
            { step === 2 && <Button type='primary' loading={loadingUrl} onClick={handleAuthUrlGet}>
              点击去授权
            </Button>}
            { step === 3 && <Button type='primary' onClick={handleSealAuthUrlGet}>
              点击去认证
            </Button>}
          </div>}
        </div>
      }
    </>
  )
};

export default SPHeader;
